import { useState, useEffect } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import slide_one from '../../resources/images/slide_one.jpg';
import slide_two from '../../resources/images/slide_two.jpg';
import slide_three from '../../resources/images/slide_three.jpg';

const slides = [slide_one, slide_two, slide_three];

const Carousel = () => {
	const [emblaRef] = useEmblaCarousel({ loop: true }, [
		Autoplay({ delay: 3000 }),
	]);

	// Tracks viewport height and updates on resize
	const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

	useEffect(() => {
		const handleResize = () => setViewportHeight(window.innerHeight);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<div
			className='carousel_wrapper'
			style={{ height: `${viewportHeight}px`, overflow: 'hidden' }}
		>
			<div ref={emblaRef} style={{ overflow: 'hidden', height: '100%' }}>
				<div style={{ display: 'flex', height: '100%' }}>
					{slides.map((slide) => (
						<div
							key={slide}
							style={{
								flex: '0 0 100%',
								background: `url(${slide}) center/cover no-repeat`,
								height: `${viewportHeight}px`,
							}}
						/>
					))}
				</div>
			</div>
		</div>
	);
};

export default Carousel;
